import React, { FC, memo } from 'react';

import AnalyticsService, { EventNameAMP } from 'application/services/AnalyticsService';

import IconDownloadReport from '@zvuk-b2b/react-uikit/ui/icons/DownloadReport';
import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';

import { CompanyPlaybackReportType } from '@shared/api/graphql/generated';

import { TEXTS } from './texts';

import styles from './index.module.scss';

type ReportCardProps = {
  emptyReportTitle?: string;
} & Partial<CompanyPlaybackReportType>;

const ReportCard: FC<ReportCardProps> = ({
  id,
  title,
  dateFrom,
  dateTo,
  reportFileUri,
  emptyReportTitle,
  reportType,
  status,
}) => {
  const dataTestId = id ? `reports_report_card_${id}` : 'reports_report_card';

  const onClick = () => {
    window.open(reportFileUri as string, '_blank');

    AnalyticsService.event(EventNameAMP.REPORT_DOWNLOAD_CLICKED, {
      reportType,
    });
  };

  const renderStatus = () => {
    const progressOrEmptyText = status === 'DONE' ? emptyReportTitle : TEXTS.IN_PROGRESS;

    if (reportFileUri) {
      return (
        <button
          type="button"
          onClick={onClick}
          className={styles.ReportsListItemLink}>
          <IconDownloadReport />
          <span className={styles.ReportsListItemLinkText}>{TEXTS.DOWNLOAD}</span>
        </button>
      );
    }

    return <span className={styles.ReportsListItemLinkTextAdditional}>{progressOrEmptyText}</span>;
  };

  return (
    <div
      className={styles.ReportsListItem}
      data-testid={dataTestId}>
      <div className={styles.PointListItemContent}>
        <h5
          className={styles.ReportsListItemContentTitle}
          data-testid={`${dataTestId}_title`}>
          {title}
        </h5>
        <div>
          <span
            className={styles.ReportsListItemContentDate}
            data-testid={`${dataTestId}_date_from`}>
            {DateUtils.getFormatDateFrom(new Date(dateFrom || null), 'dd.MM.yyyy')}
          </span>
          —
          <span
            className={styles.ReportsListItemContentDate}
            data-testid={`${dataTestId}_date_to`}>
            {DateUtils.getFormatDateFrom(new Date(dateTo || null), 'dd.MM.yyyy')}
          </span>
        </div>
      </div>
      {renderStatus()}
    </div>
  );
};

export default memo(ReportCard);
